var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738506 17.3176L0.738473 17.4673L0.867456 17.5431L12.8383 24.582L12.9704 24.6597L13.1028 24.5824L23.4549 18.5307V20.4269L12.9713 26.6096L1.7467 19.9428L1.61592 19.8652L1.48375 19.9405L0.871669 20.2891L0.739589 20.3643V20.5163V21.3878V21.5374L0.868514 21.6132L12.8383 28.6533L12.9708 28.7312L13.1034 28.6533L25.0742 21.6155L25.2032 21.5397V21.3901V16.5039V16.3592L25.0806 16.2823L24.5226 15.9326L24.3877 15.848L24.2507 15.9291L12.9717 22.5979L2.54308 16.3557V14.4595L12.8383 20.5097L12.9709 20.5876L13.1034 20.5097L25.0742 13.4719L25.2032 13.3961V13.2465V8.41691V8.27195L25.0802 8.19514L24.5223 7.84654L24.3875 7.7623L24.2507 7.84321L12.9708 14.5126L3.35221 8.8255L12.9712 3.13824L21.2449 8.00395L21.3836 8.08549L21.5189 7.99851L22.2426 7.53333L22.3627 7.45613V7.31336V6.67274V6.52372L22.2344 6.44776L13.1041 1.03869L12.9708 0.959707L12.8375 1.03873L0.86665 8.13538L0.738506 8.21134V8.36031V9.17524V9.32485L0.867487 9.40067L12.8383 16.4373L12.9705 16.515L13.1028 16.4376L23.4549 10.3859V12.3388L12.9713 18.526L1.7467 11.8592L1.61592 11.7816L1.48375 11.8568L0.871669 12.2055L0.739623 12.2807L0.739589 12.4326L0.738506 17.3176Z",
    fill: "#F9C43C",
    stroke: "#F9C43C",
    strokeWidth: 0.522988
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.9c6963cf22ec27648e8fbe96df290385.svg";
export { ForwardRef as ReactComponent };